// Rechargement automatique au deploy. Chaque réponse API porte la version
// déployée (en-tête X-SvpApp-Version, bakée au build côté serveur) ; si elle
// diffère de celle de CE bundle, le bandeau « Nouvelle version disponible »
// s'affiche. Revue 6 (D10, Jordan 10.10) : rechargement seulement au
// CHANGEMENT DE PAGE ou quand l'onglet est MASQUÉ, jamais en pleine page (ou
// au clic). Pas de déconnexion : le jeton reste en localStorage.
//
// Revue 6 (🟠9) : AUCUN import ici (ni Addons, ni store) — versionDeploiement
// est chargé par apiHelpers, lui-même chargé par Addons : un import d'Addons
// formait un cycle (MA_VERSION undefined sur /ecran, TDZ en dev).

export const APP_VERSION = process.env.REACT_APP_VERSION || "dev"
const APP_GIT_SHA = process.env.REACT_APP_GIT_SHA || ""

export const MA_VERSION = APP_GIT_SHA
	? `${APP_VERSION}+${APP_GIT_SHA}`
	: APP_VERSION

let nouvelle = null
const abonnes = new Set()
const saisiesSales = new Set()
const CLE_RECHARGE = "svp_recharge_version"

// Revue 6 (R5) : seulement un build de production (npm start injecte aussi
// REACT_APP_VERSION : un front de dev pointé sur une stack docker ne doit
// jamais se recharger).
export const rechargementActif = () =>
	process.env.NODE_ENV === "production" && APP_VERSION !== "dev"

// Appelée sur chaque réponse (apiHelpers.handleErrors).
export const noterVersionServeur = (v) => {
	if (!rechargementActif()) return
	if (!v || v === MA_VERSION || v === nouvelle) return
	nouvelle = v
	abonnes.forEach((cb) => cb(v))
}

// Variable CSS posée sur <html> par une page à barre fixe en bas d'écran
// (hauteur en px) : le bandeau « Nouvelle version » se pose au-dessus.
export const BARRE_FIXE_BAS = "--barre-fixe-bas"

export const abonnerNouvelleVersion = (cb) => {
	abonnes.add(cb)
	if (nouvelle) cb(nouvelle)
	return () => abonnes.delete(cb)
}

// useQuitGuard : une fiche aux modifications non sauvegardées.
export const marquerSaisie = (cle, sale) => {
	if (sale) saisiesSales.add(cle)
	else saisiesSales.delete(cle)
}

// Une fiche « dirty » (useQuitGuard) : jamais de rechargement automatique,
// même au changement de page ou onglet masqué.
export const saisieEnCours = () => saisiesSales.size > 0

// Revue 7 (🟠B, Q3) : à l'onglet MASQUÉ, garde-fous prudents en plus — un
// champ actif ou un modal ouvert (CustomModal, react-responsive-modal) peut
// porter une saisie hors fiche suivie (e-mail, modal de commande…).
export const saisieOuverte = () => {
	if (saisieEnCours()) return true
	const actif = document.activeElement
	if (
		actif &&
		(["INPUT", "TEXTAREA", "SELECT"].includes(actif.tagName) ||
			actif.isContentEditable)
	)
		return true
	// react-responsive-modal v4 : classes CSS-modules, seul aria-modal est
	// stable (les classes react-responsive-modal-* n'existent qu'en v5).
	return !!document.querySelector('[data-custom-modal], [aria-modal="true"]')
}

// Anti-boucle : une seule recharge AUTOMATIQUE par version annoncée (si le
// bundle servi reste l'ancien — cache, proxy —, on garde le bandeau).
export const rechargementAutoPermis = (v) => {
	try {
		return sessionStorage.getItem(CLE_RECHARGE) !== v
	} catch (e) {
		return true
	}
}

export const recharger = (v) => {
	try {
		sessionStorage.setItem(CLE_RECHARGE, v)
	} catch (e) {
		// stockage indisponible : recharge quand même
	}
	window.location.reload()
}

// Revue 6 (R1) : nom du bundle principal (main.<hash>.js) d'un HTML.
const MAIN_JS =
	/\/static\/js\/main\.[0-9a-f]+\.chunk\.js|\/static\/js\/main\.[0-9a-f]+\.js/
export const bundleDe = (html) => {
	const m = MAIN_JS.exec(html || "")
	return m ? m[0] : null
}
const bundleCourant = () => {
	const src = Array.from(document.scripts || [])
		.map((s) => s.getAttribute("src") || "")
		.find((s) => bundleDe(s))
	return src ? bundleDe(src) : null
}

// Revue 7 (Re4) : la page répond-elle (HTML avec un bundle) ? Jamais de
// rechargement vers une page d'erreur (502 pendant un deploy).
export const pageServie = (chemin) =>
	fetch(chemin, { cache: "no-store" })
		.then((r) => (r.ok ? r.text() : Promise.reject(r.status)))
		.then((html) => !!bundleDe(html))
		.catch(() => false)

// Revue 6 (R1) : la page servie MAINTENANT porte-t-elle un autre bundle ?
// → Promise<bool>. Faux si elle ne répond pas (502 pendant le deploy) :
// l'écran TV ne se recharge jamais sur une page d'erreur — réessai au
// sondage suivant.
export const nouveauBundleServi = (chemin) =>
	fetch(chemin, { cache: "no-store" })
		.then((r) => (r.ok ? r.text() : Promise.reject(r.status)))
		.then((html) => {
			const servi = bundleDe(html)
			return !!servi && servi !== bundleCourant()
		})
		.catch(() => false)
